import React from 'react';
import { createIcon } from './create-icon';
import './icon-upload-asset-success.scss';

export const IconUploadAssetSuccess = createIcon(<div className="icon-upload-asset-success" />);
